import { Box, Button, TextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router';
import { userLoginRequest } from '../actions/auth';
import { useAppDispatch, useAppSelector } from '../hooks';
import ErrorList from './ErrorList';

interface Credentials {
  email: string;
  password: string;
}

interface Props {
  loggedOut?: boolean;
}

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function LoginForm({ loggedOut = false }: Props) {
  const dispatch = useAppDispatch();
  const errorMessages = useAppSelector((s) => s.auth.errorMessages);
  const {
    register,
    handleSubmit,
    formState: { errors, isValid }
  } = useForm<Credentials>({ mode: 'onChange', defaultValues: { email: '', password: '' } });

  return (
    <div className="loginForm">
      {loggedOut && <p className="loggedOutMessage">Zostałeś wylogowany</p>}
      <ErrorList errorMessages={errorMessages} />
      <div className="logoWrapper">
        <div className="logo" />
        <h2 className="logoText">GWAŁTOMAT</h2>
      </div>
      <Box
        component="form"
        onSubmit={handleSubmit((data) => dispatch(userLoginRequest(data)))}
        sx={{ maxWidth: 340, mx: 'auto' }}
      >
        <TextField
          {...register('email', { required: true, pattern: EMAIL })}
          className="emailField"
          label="Email"
          type="text"
          fullWidth
          margin="normal"
          error={Boolean(errors.email)}
          helperText={errors.email ? 'Adres email jest niepoprawny' : ''}
        />
        <TextField
          {...register('password', { required: true })}
          className="passwordField"
          label="Hasło"
          type="password"
          fullWidth
          margin="normal"
          error={Boolean(errors.password)}
          helperText={errors.password ? 'Hasło jest wymagane' : ''}
        />
        <Button
          type="submit"
          variant="contained"
          size="large"
          fullWidth
          disabled={!isValid}
          sx={{ mt: 2 }}
        >Zaloguj</Button>
        <Link to="/register" className="registerLink">Zarejestruj się</Link>
      </Box>
    </div>
  );
}
